import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';
import NotificationBell from '../NotificationBell.jsx';
import ThemeToggle from '../theme/ThemeToggle.jsx';
import './Navbar.css';

const Navbar = () => {
  const { user } = useAuth();
  const location = useLocation();

  // Don't show navbar on login/register pages
  if (location.pathname === '/login' || location.pathname === '/register') {
    return null;
  }

  return (
    <nav className={`navbar ${user ? 'navbar-with-sidebar' : ''}`}>
      <div className="container">
        <div className="navbar-content">
          {/* Left section with branding */}
          <div className="navbar-left-section">
            <div className="navbar-brand">
              <h2>Learn 2 Trade</h2>
            </div>
          </div>

          {/* Right section */}
          {user && (
            <div className="navbar-user-section">
              <NotificationBell />
              <div className="ml-3">
                <ThemeToggle />
              </div>
            </div>
          )}
          {!user && (
            <div className="auth-links">
              <Link to="/login" className="nav-link">
                Login
              </Link>
              <Link to="/register" className="btn btn-primary">
                Sign Up
              </Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;